export const POSTULANTS_INDEX__SET_ALL = 'POSTULANTS_INDEX__SET_ALL';
export const POSTULANTS_INDEX__ADD_RESOURCE = 'POSTULANTS_INDEX__ADD_RESOURCE';
export const POSTULANTS_INDEX__UPDATE_RESOURCE = 'POSTULANTS_INDEX__UPDATE_RESOURCE';
export const POSTULANTS_INDEX__REMOVE_RESOURCE = 'POSTULANTS_INDEX__REMOVE_RESOURCE';
export const POSTULANTS_INDEX__CLEAR_ALL = 'POSTULANTS_INDEX__CLEAR_ALL';
